import { useMemo } from 'react';
import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { InstantInputDialogContents, Modal } from '@repo/ui';

import { selectParkStartAtTimestamp, useParkingSearchStore } from '@shared/stores/useParkingSearchStore';

interface Props {
  testId: TestId;
}

export default function InstantInputDrawer({ testId }: Props) {
  const startAtTimestamp = useParkingSearchStore(selectParkStartAtTimestamp);
  const parkStart = useMemo(
    () => (startAtTimestamp !== undefined ? new Date(startAtTimestamp) : undefined),
    [startAtTimestamp]
  );
  const setParkStart = useParkingSearchStore((state) => state.setParkStart);
  const isParkStartDrawerOpen = useParkingSearchStore((state) => state.isParkStartDrawerOpen);
  const setIsParkStartDrawerOpen = useParkingSearchStore((state) => state.setIsParkStartDrawerOpen);

  const handleClose = () => setIsParkStartDrawerOpen(false);

  const handleCommit = (value: Date) => {
    setParkStart(value);
    handleClose();
  };

  return (
    <Modal
      testId={testId}
      title={tr('parking_search:park_start.label')}
      open={isParkStartDrawerOpen}
      onOpenChange={setIsParkStartDrawerOpen}
      flush
      width="sm"
    >
      <InstantInputDialogContents
        testId={testId.append('contents')}
        mode="datetime"
        open={isParkStartDrawerOpen}
        value={parkStart}
        onChange={handleCommit}
        disablePast
      />
    </Modal>
  );
}
